import React from "react";
import { motion } from "framer-motion";
import Testimonials from "../components/Testimonials";

const TestimonialsPage = () => {
  return (
    <>
      <Testimonials />
    </>
  );
};

export default TestimonialsPage;
